<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Clients vendeurs",
          icon: "bi bi-people-fill",
          route: "seller-customers-index",
        },
        {
          label: "Nouveau client",
          icon: "bi bi-person-plus-fill",
          route: "seller-customers-create",
        },
      ],
    };
  },
};
</script>
